"use strict";

const Checkout = () => {
    const init = () => {
        $(function() {

            $(document).on('click','.js-cart-input-down', function (e) {
                e.preventDefault();

                var $input = $(this).parents('.js-cart-form').find('.js-cart-input');
                let value = parseInt($input.val()) || 1;
                if(value > 1) {
                    $input.val(value - 1);
                }
                updateCheckoutCost($input);
            });

            $(document).on('click','.js-cart-input-up', function (e) {
                e.preventDefault();

                var $input = $(this).parents('.js-cart-form').find('.js-cart-input');
                let value = parseInt($input.val()) || 1;
                $input.val(value + 1);
                updateCheckoutCost($input);
            });

            $(document).on('change','.js-cart-input', function (e) {
                e.preventDefault();

               updateCheckoutCost($(this));
            });

            $(document).on('click','.js-add-to-cart', function (e) {
                e.preventDefault();

                updateCheckoutCost($(this).parents('.js-add-cart-form-container').find('.js-cart-input'));

                openPopout('cart-popout');

                $('.js-view-cart').addClass('active');
            });

            $(document).on('click','.js-view-cart', function (e) {
                e.preventDefault();

                openPopout('cart-popout');
            });

            $(document).on('click','.js-remove-from-cart', function (e) {
                e.preventDefault();

                var $input = $('.js-cart-input').val(1);
                updateCheckoutCost($input);
                $('.js-view-cart').removeClass('active');
                closePopout();
            });

            function updateCheckoutCost($input) {
                var cost = parseFloat($input.parents('.js-cart-form').attr('data-price'));
                var amount = parseInt($input.val(), 10);

                // Fall back to sane values so an empty input or missing price does not
                // render '$NaN'
                if (isNaN(amount) || amount < 1) {
                    amount = 1;
                }
                if (isNaN(cost)) {
                    cost = 0;
                }

                var total_cost = amount * cost;

                $('.js-cart-popout').find('.js-cart-input').val(amount);
                $('.js-cart-popout').find('.product-price-price').html('$' + total_cost.toLocaleString());

                var $checkout_button = $('.js-checkout-button');
                var href = $checkout_button.attr('href');

                // Nothing to update when the button is not on the page
                if (!$checkout_button.length || typeof href === 'undefined') {
                    return;
                }

                // Replace or add qty parameter
                if (href.match(/([?&]qty=)\d+/)) {
                    href = href.replace(/([?&]qty=)\d+/, '$1' + amount);
                } else {
                    href += (href.indexOf('?') > -1 ? '&' : '?') + 'qty=' + amount;
                }

                $checkout_button.attr('href', href);
            }

        });
    };

    return {
        init:init
    };
};

export default Checkout;